import styled from 'styled-components'

export const ActionListHeading = styled.div`
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.ink.base};
  font-size: 12px;
  text-transform: uppercase;
`

export const ActionList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 8px 0;
  & + & {
    border-top: 1px solid ${({ theme }) => theme.colors.sky.base};
  }
`

export const ActionListItem = styled.li`
  button,
  a {
    appearance: none;
    margin: 0;
    padding: 0;
    background: none;
    border: none;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    color: inherit;
    text-decoration: none;
    text-transform: none;
    display: block;
    width: 100%;
    min-height: 40px;
    padding: 8px 16px;
    text-align: left;
    cursor: pointer;
    border-radius: 0;
    white-space: nowrap;
    &:hover {
      background-color: ${({ theme }) => theme.colors.primary.lightest};
    }
    span {
      font-weight: inherit;
      justify-content: flex-start;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/ActionList/ActionList.styled.js